export const candadoConstants = {
    MAXIMA_PRIORIDAD:1000,
    GETALL_REQUEST_CANDADO: 'GETALL_REQUEST_CANDADO',
    GETALL_SUCCESS_CANDADO: 'GETALL_SUCCESS_CANDADO',
    GETALL_FAILURE_CANDADO: 'GETALL_FAILURE_CANDADO',
};